import { getCookie } from '../utils/cookie';
import type { ConsentStrategy } from './ConsentStrategy';

/**
 * Cookie the plugin registers in Shopware's native cookie manager (see
 * `Birdsview\Client\Goose\Service\Cookie\CookieProviderDecorator`). Shopware's own
 * cookie-configuration JS writes it on accept and removes it when the entry is unticked, so
 * the plugin ships no storefront JS for consent capture.
 */
export const BV_TRACKING_COOKIE = 'bv-tracking';

/**
 * Terminal fallback: always present, so a shop with no CMP resolves here and fails closed.
 *
 * Only our own cookie counts. `cookie-preference` presence must never be read as consent
 * because Shopware's native banner sets `cookie-preference=1` on *Deny* too
 * (`cookie-permission.plugin.js` `_handleDenyButton`) — that was the deny-hole this replaces.
 */
export class ShopwareNativeStrategy implements ConsentStrategy {
  readonly name = 'shopware-native';

  isPresent(): boolean {
    return true;
  }

  hasConsent(): boolean {
    return getCookie(BV_TRACKING_COOKIE) === '1';
  }
}
